import { deleteDoc, doc } from '@firebase/firestore';
import { Button, Modal } from 'antd';
import { initializeApp } from 'firebase/app';
import { child, getDatabase, push, ref, remove, update } from 'firebase/database';
import { collection, limit, getDocs, getFirestore, orderBy, query, updateDoc } from 'firebase/firestore';
import React, { PureComponent, useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { AuthContext } from '../../context/auth';
import { SelectContext } from '../../context/select';
import { TaskContext } from '../../context/task';
import { TotalViewContext } from '../../context/totalview';
import { firebaseConfig } from '../../firebaseConfig';
import logo from '../../img/kOnzy.gif';

export default function UpdateTask() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const [task, setTask] = useState();
    const [postedBy, setPostedBy] = useState("");

    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);

    const [selects, setSelects] = useContext(SelectContext);
    const [loading, setLoading] = useState();
    const [loading2, setLoading2] = useState();
    const [tasks, setTasks] = useContext(TaskContext);
    const [auth, setAuth] = useContext(AuthContext);
    const [totalView, setTotalView] = useContext(TotalViewContext);
    const [page, setPage] = useState();

    useEffect(() => {

        if (selects !== null) {

            setTask(selects.select.task)
            setSelects(selects)
            console.log("selects", selects.select.id)
        }


    }, [selects])


    console.log(selects)

    const canUpdate = auth.email === selects?.select?.postedBy





    const handleOk = () => {
        setSelects(null);
    };
    const handleCancel = () => {
        setSelects(null);
    };

    const UpdateTask = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {

            const UpdateTaskRef = doc(db, "task", selects.select.id);
            const date = new Date().getTime()
            // Set the "capital" field of the city 'DC'
            await updateDoc(UpdateTaskRef, {
                task,
                updatedTime: String(new Date(date))
            })
            const c = tasks.findIndex(x => x.id === selects.select.id);
            tasks[c].task = task
            console.log("ssssss", tasks);
            setTasks(tasks)
            toast.success("tasks updated")
            setLoading(false)

            handleOk()
        } catch (error) {
            setLoading(false)
            toast.error("tasks updated failed")
            toast.error("error" + error.message)
        }

    }
    const deleteRealtime = async (e) => {
        try {
             e.preventDefault();
        setLoading2(true)
        const db = getDatabase();
        const date = new Date().getTime()
        // A post entry.
        const postData = null


        // Write the new post's data simultaneously in the posts list and the user's post list.
        const updates = {};
        updates['/tasks/' + selects.select.id] = postData;


        update(ref(db), updates);
        toast.success("tasks deleted")

        setLoading2(false)

        handleOk()
        } catch (error) {
            toast.error("can not delete tasks /n"+ error.message)
        }
       
    }
    const updateRealTask = async (e) => {
        e.preventDefault();
        // 
        try{
            setLoading(true)
                
        const db = getDatabase();
        const date = new Date().getTime()
        // A post entry.
        const postData = {
            task: task,
            id: selects.select.id,
            postedBy: selects.select.postedBy,
            timeCreated: selects.select.timeCreated,
            updatedTime: String(new Date(date))
        };


        // Write the new post's data simultaneously in the posts list and the user's post list.
        const updates = {};
        updates['/tasks/' + selects.select.id] = postData;


        update(ref(db), updates);
        toast.success("tasks updated")
        setLoading(false)

        handleOk()
    } catch (error) {
        setLoading(false)
        toast.error("tasks updated failed")
        toast.error("error" + error.message)
    }

    }
    const deleteTask = async (e) => {
        e.preventDefault();
        setLoading2(true)
        try {

            const UpdateTaskRef = doc(db, "task", selects.select.id);

            await deleteDoc(UpdateTaskRef)

            const newArr = tasks.filter(object => {
                return object.id !== selects.select.id;
            });
            setTasks(newArr)


            // console.log("ssssss", tasks);
            setTotalView(pre => ({ ...totalView, totalView: pre.totalView - 1, total: pre.total - 1 }))
            toast.success("tasks deleted")

            setLoading2(false)

            handleOk()

        } catch (error) {
            setLoading2(false)
            toast.error("tasks deleted failed")
            toast.error("error" + error.message)
            toast.error("error" + error.message)
        }

    }



    return (
        <>

            <Modal open={selects !== null} onOk={handleOk} onCancel={handleCancel} footer={null}>
                <Toaster />

                <form className='d-flex justify-content p-3'>
                    <textarea className='form-control m-1' value={task} maxLength={160} onChange={(e) => setTask(e.target.value)} placeholder='Write' ></textarea>

                    {canUpdate ? (
                        <>
                            <button onClick={updateRealTask} type='submit' className='btn btn-primary m-1'>{loading ? (<img src={logo} alt="loading" style={{ height: "20px" }} />) : "Submit"} </button>
                            <button onClick={deleteRealtime} type='submit' className='btn btn-danger m-1'>{loading2 ? (<img src={logo} alt="loading" style={{ height: "20px" }} />) : "Delete"} </button>
                        </>
                    ) : (

                        <>
                            <button className='btn btn disabled m-1'>
                                By {selects?.select?.postedBy}
                            </button>


                        </>
                    )}

                </form>
            </Modal>

            <pre>                       {JSON.stringify(tasks, null, 4)}</pre>
        </>
    )

}
